import './styles.scss';

export const TooltipContent = ({
  dateStr,
  items,
}: {
  dateStr: string;
  items: Array<{ color: string; name: string; value: number; seriesType?: string; delta?: string }>;
}) => {
  const formatValue = (value: number, seriesType?: string, _?: string) => {
    if (seriesType === 'PERPETUAL') {
      return new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    } else {
      return `${(value * 100).toFixed(2)}%`;
    }
  };

  return (
    <div className="tv-tooltip">
      <div className="tv-tooltip-date">{dateStr}</div>
      <div className="tv-tooltip-items">
        {items.map((it, i) => (
          <div className="tv-tooltip-row" key={i}>
            <span className="tv-tooltip-dot" style={{ background: it.color }} />
            <span className="tv-tooltip-name">{it.name}</span>
            <span className="tv-tooltip-value">
              {formatValue(it.value, it.seriesType, it.delta)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};
